import { Injectable } from '@angular/core';
import { FieldChanger, NodeNamer, TreeListService } from './tree-list.service';

export class PumpListNode {
  id: string;
  text: string;
  items: PumpListNode[];
}

@Injectable()
export class PumpListService {

  private pumpFamilies = [
    { family: "iH",   application: "Semicon",     label: "iH Pumps",   division: "semicon" },
    // { family: "iGX",  application: "Semicon",     label: "iGX Pumps",  division: "semicon" },
    { family: "iXH",  application: "Semicon",     label: "iXH Pumps",  division: "semicon" },
    { family: "iXL",  application: "Semicon",     label: "iXL Pumps",  division: "semicon" },
    // { family: "iXM",  application: "Semicon",     label: "iXM",  division: "semicon" },
    { family: "nXLi", application: "Scientific",  label: "nXLi", division: "scientific" },
    { family: "nXRi", application: "Scientific",  label: "nXRi", division: "scientific" },
    { family: "ESDP", application: "Scientific",  label: "Scroll Pumps", division: "scientific" },
    { family: "nXDS", application: "Scientific",  label: "Scroll Pumps nXDS", division: "scientific" },
    { family: "XDS",  application: "Scientific",  label: "Scroll Pumps",  division: "scientific" },
    { family: "ED660",  application: "Scientific",  label: "Small Rotary Pumps",  division: "scientific" },
    { family: "E1M",  application: "Scientific",  label: "Small Rotary Pumps",  division: "scientific" },
    { family: "E2M",  application: "Scientific",  label: "Small Rotary Pumps",  division: "scientific" },
    { family: "RV",   application: "Scientific",  label: "Small Rotary Pumps",  division: "scientific" },
    { family: "EDC",  application: "Industrial",  label: "EDC",  division: "industrial" },
    { family: "EDO",  application: "Industrial",  label: "EDO",  division: "industrial" },
    { family: "EDS",  application: "Industrial",  label: "EDS Pumps",  division: "industrial" },
    { family: "EHR",  application: "Industrial",  label: "EHR",  division: "industrial" },
    { family: "ELRi", application: "Industrial",  label: "ELRi", division: "industrial" },
    // { family: "ES",   application: "Industrial",  label: "ES Pumps",   division: "industrial" },
    { family: "EXS",   application: "Industrial",  label: "EXS",   division: "industrial" },
    { family: "GV",   application: "Industrial",  label: "GV Pumps",   division: "industrial" },
    { family: "GXS",  application: "Industrial",  label: "GXS Pumps",  division: "industrial" },
    { family: "IDX",  application: "Industrial",  label: "IDX Pumps",  division: "industrial" },
    { family: "nES",  application: "Industrial",  label: "nES Pumps",  division: "industrial" },
    { family: "E1M",  application: "Industrial",  label: "Large Rotary Pumps",  division: "industrial" },
    { family: "E2M",  application: "Industrial",  label: "Large Rotary Pumps",  division: "industrial" },
    { family: "SHR",  application: "Industrial",  label: "Liquid Ring Pumps",  division: "industrial" },
    { family: "CDX",  application: "Chemical",    label: "CDX Pumps",  division: "industrial" },
    { family: "CXS",  application: "Chemical",    label: "CXS Pumps",  division: "industrial" },
    { family: "EDP",  application: "Chemical",    label: "EDP Pumps",  division: "industrial" }
  ];

  constructor(private treeListService:TreeListService) { }

  /**
   * Builds a pump tree list organised by offical->Application->family and "My Pumps" user defined pumps
   * @param pumpData
   */
  getPumpTreeList(pumpData): PumpListNode[] {
    let applications = {};
    applications["Chemical"] = {};
    applications["Industrial"] = {};
    applications["Scientific"] = {};
    applications["Semicon"] = {};
    for (let pumpFamily of this.pumpFamilies) {
        if(!applications[pumpFamily.application][pumpFamily.label]) {
            applications[pumpFamily.application][pumpFamily.label] = [];
        }
    }
    for (let pump of pumpData) {
        var blnFamilyFound = false;
        for (let pumpFamily of this.pumpFamilies) {
            if (pump.name.substring(0,3).match(new RegExp(pumpFamily.family.substring(0,3)))) {
                if (pump.division[0] == pumpFamily.division) {
                    blnFamilyFound = true;
                    applications[pumpFamily.application][pumpFamily.label].push({id:pump.id, name:pump.name, dataComment:pump.description, numberOfBoosterLayers:pump.numberOfBoosterLayers });
                    break;
                }
            }
        }
        if (blnFamilyFound == false) {
            if (!applications["Other pumps"]) {
                applications["Other pumps"] = {};
                applications["Other pumps"]["All"] = [];
            }
            applications["Other pumps"]["All"].push({id:pump.id, name:pump.name, dataComment:pump.description, numberOfBoosterLayers:pump.numberOfBoosterLayers });
        }
    }
    let applicationNodes = [];
    Object.keys(applications).forEach(function(key, index) {
            let applicationNode =  { isExpanded:false, id: key, text: key, items: []};
            Object.keys(applications[key]).forEach((function(key_, index_) {
              let familyNode = { id:key_, text: key_, items: []};
              for (let pump of applications[key][key_]) {
                let pumpNode = { id:pump.id, text: pump.name, name:pump.name, dataComment: pump.dataComment, numberOfBoosterLayers:pump.numberOfBoosterLayers, items: []};
                familyNode.items.push(pumpNode);
              }
              applicationNode.items.push(familyNode);
            }));
            applicationNodes.push(applicationNode);
     });
     let result = [];
     let officialNode = { isExpanded:true, id:"official", text: "Official", items: applicationNodes };
     result.push(officialNode);
     return result;
    }

    getCustomPumpItems(customPumpData){
      let customPumpfieldChanger:FieldChanger = {
        changeNames: (obj: any):any => {
          obj.text=obj.name;
          obj.isUser=true;
          return obj;
        }
      };
      let customPumpsNodeNamers:NodeNamer[] = [
        {getNodeName: (obj: any) => {
          return "My Pumps";
        }},
      ];
      return this.treeListService.getTree(customPumpData,customPumpfieldChanger,customPumpsNodeNamers);
    }

  }

